function Alert(props) {
  return (
    <div className="alert">
      <div className="flex justify-end w-5">
        <div
          className="rounded-full w-[3px] h-[3px]"
          style={{
            backgroundColor: props.color === "red" ? "#ff2877" : "#32f75f",
          }}
        ></div>
      </div>
      <div className="alert-text">{props.txt}</div>
    </div>
  );
}

export default Alert;
